import { render } from "./UserSedutePt.vue?vue&type=template&id=03312510&scoped=true"
import script from "./UserSedutePt.vue?vue&type=script&lang=js"
export * from "./UserSedutePt.vue?vue&type=script&lang=js"

import "./UserSedutePt.vue?vue&type=style&index=0&id=03312510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03312510"]])

export default __exports__